import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { share } from 'rxjs/operators';
import { UtilService } from './util.service';

@Injectable()
export class SpinnerService {
  private spinnerObserver: Observer<any>;
  public spinnerObservable: Observable<any>;
  private runningEvents: any[];
  constructor(private utilService: UtilService) {
    this.runningEvents = [];
    this.spinnerObservable = new Observable(observer => {
      this.spinnerObserver = observer;
    }).pipe(share());
  }

  show(url: any = null, componentIds = "") {
    if (componentIds) {
      let components = componentIds.split('.');
      let comp = null;
      if (components.length > 1) {
        for (let c of components) {
          comp = this.utilService.getComponentRef(c);
          if (!comp) continue;
          comp.showHideSpinner(true);
        }
      } else {
        comp = this.utilService.getComponentRef(components[0]);
        if (!comp) return;
        comp.showHideSpinner(true);
      }
      return;
    }
    url ? this.runningEvents.push(url) : null;
    if (this.spinnerObserver) {
      this.spinnerObserver.next(true);
    }
  }

  showOnComponent(cId, url) {

  }

  hide(url: any = null, componentIds = "") {
    if (componentIds) {
      let components = componentIds.split('.');
      let comp = null;
      if (components.length > 1) {
        for (let c of components) {
          comp = this.utilService.getComponentRef(c);
          if (!comp) continue;
          comp.showHideSpinner(false);
        }
      } else {
        comp = this.utilService.getComponentRef(components[0]);
        if (!comp) return;
        comp.showHideSpinner(false);
      }
      return;
    }
    if (!this.isRunning(url) && this.spinnerObserver) {
      this.spinnerObserver.next(false);
    }
  }

  private isRunning(url) {
    this.runningEvents = this.runningEvents.filter(eventUrl => eventUrl != url);
    return (this.runningEvents.length > 0)
  }
}

